import React, { Component } from "react";
import { TABLES } from '../../managers/TableManger';
import Utility, { deepClone } from "../../utility/Utility";
import DataGridHolderPayroll from '../common/DataGridHolderPayroll';
import { parseColumnConfig, parseVisibleColumnConfig } from '../configs/config';
import { FORMULA_COMPONENT_LIST } from "./ComponentConstants";
import { DKButton, DKInput, showToast} from "deskera-ui-library";
import { getNextChar, isOperator } from "../../managers/common/CommonUtil";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";


export default class FormulaGrid extends Component {
    
    gridContainer = React.createRef();
    grid = {
        gridActions: {
            filters: [],
            currentPage: 1,
            totalPageCount: 1
        },
        gridData: {
            columnData:parseVisibleColumnConfig(parseColumnConfig(FORMULA_COMPONENT_LIST)),
            rowData: [],
            filter: [],
            originalData: []
        },
        canValidate: false
    }
    isFormulaValid = true;
    isGridValid = true;
    constructor(props) {
        super(props)
        
        
        this.state = {
            
            gridWidthgridWidth:950,
            componentList:props.componentList,
            formula:this.props.componentData.formula
        }
        this.setComponentList(props)
    }
    componentDidMount() {
        this.setState({
            ...this.state,
            gridWidth: (this.gridContainer?.current?.clientWidth || 950)
        })
    }
    componentWillReceiveProps(nextProps) {
        this.setComponentList(nextProps)
        this.setState({
            componentList: nextProps.componentList
        });
    }
    componentDidUpdate() {
        if(this.props.onValueFormulaUpdate) {
            this.isGridValid = !this.grid.gridData.rowData?.some(col=>(col.invalidFields && col.invalidFields.length!=0))
            let data = {
                formula :this.state.formula,
                formulaConfig: this.grid.gridData.rowData,
                isFormulaValid: this.isFormulaValid && this.isGridValid
            }
            this.props.onValueFormulaUpdate(data)
        }
    }
    setComponentList(props) {
        let componentList = props.componentList
        let columns = deepClone(FORMULA_COMPONENT_LIST)
        if(!Utility.isEmpty(componentList)) {
            let index = columns.findIndex(field=>field.columnCode == "componentId");
            if(index!=-1) {
                let activeComponent = componentList.filter(c=>(c.isActive && c.subType !== "fixed_allowance" && !c.isFormula && (c.id != this.props.componentData.id)))
                columns[index].options = [{id:'ctc',name:"CTC"},...activeComponent];
                this.grid.gridData.columnData[index].options = [{id:'ctc',name:"CTC"},...activeComponent];
            }
            if(props.componentData.formulaConfig) {
                this.grid.gridData.rowData = [...props.componentData.formulaConfig]
            }
        }
    }
    updateState() {
        this.setState({
            ...this.state
        })
    }
    onRowUpdate(data) {
        
        let fieldIndex = data.rowData?.invalidFields ? data.rowData.invalidFields.findIndex(f=>f==data.columnKey) : -1;
        let isDuplicateDate = this.grid.gridData.rowData?.find(row=>(row.componentId && data.rowData?.componentId && row.componentId[0] && data.rowData.componentId[0] && row.componentId[0]==data.rowData.componentId[0] && data.rowData.index !== row.index))
        if(data.columnData.required && (Utility.isEmpty(data.rowData[data.columnKey]) ||( typeof(data.rowData[data.columnKey]) == 'string' && Utility.isEmpty(data.rowData[data.columnKey].trim())   ) || (data.columnKey == 'percentage' && (data.rowData[data.columnKey]<0 || data.rowData[data.columnKey] >100) ) || isDuplicateDate)) {
            if(fieldIndex == -1 && data.rowData['invalidFields']) {
                data.rowData['invalidFields'].push(data.columnKey)
            } else if(fieldIndex == -1&& !data.rowData['invalidFields']) {
                data.rowData['invalidFields'] = [];
                data.rowData['invalidFields'].push(data.columnKey)
            }
            if(isDuplicateDate) {
                showToast("Selected Component already added.")
            }
        } else if(fieldIndex != -1) {
            data.rowData['invalidFields'].splice(fieldIndex,1)
        }
        this.updateState()
        
    }
    addRow() {
        let index = this.grid.gridData.rowData?.length -1
        let nextChar
        if(index == -1) {
            nextChar = 'A'
        } else {
            nextChar = getNextChar(this.grid.gridData.rowData[index].index)
        }
        
        this.grid.gridData.rowData?.push({
            index:nextChar,
            componentId:null,
            percentage:"100",
            invalidFields:["componentId"]
        })
        this.updateState()
    }
    onRowDelete(data) {
        this.grid.gridData.rowData?.splice(data.rowIndex,1);
        this.grid.gridData.rowData?.forEach((row,index)=>{
            if(Utility.isEmpty(row.index)|| index == 0) {
                row.index = 'A'
            } else {
                row.index = getNextChar(this.grid.gridData.rowData[index-1].index)
            }
        })
        this.updateState()
    }
    getAddRowButton() {
        return (
            <DKButton className="text-app fw-m" title="+ Add Component" onClick={()=>{
                setTimeout(()=>{
                    this.addRow()
                },100)
            }}/>
        )
    }
    formulaField() {
        return (
            <DKInput 
                    title="Formula"
                    className="mt-l"
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    placeholder="()"
                    canValidate={true}
                    errorMessage="Please enter valid expression"
                    
                    tooltip={{
                        content: "Expression should be based on Id of Earning/Deduction. <br> eg.((A + B) * 0.15) ",
                        className: "warning-tooltip-prop",
                    }}
                    validator={(value)=>{
                        let a = value.replace(/[a-zA-Z]/g, '1')
                        let isValid = true;
                        if (value.length != 0) {
                            let keyIndex = value.match(/[a-zA-Z]/g);
                            keyIndex?.forEach(cc => {
                                if (!this.grid.gridData.rowData?.some(r => r.index == cc)) {
                                    isValid = false
                                }
                            })
                        }
                        if(Utility.isEmpty(value.trim())) {
                            isValid = false;
                        }
                        try {
                            
                            eval(a);
                        } catch (e) {
                            isValid = false;
                        }
                        this.isFormulaValid = isValid;
                        return isValid
                    }}
                    value={this.state.formula}
                    onChange={(value)=>{
                       this.setState({
                        formula:value
                       })
                    }}
                    />
        )
    }
    evil(fn) {
        return new Function('return ' + fn)();
      }
    getGrid() {
        return(
            <>
            <div className="column parent-width flex-1 " style={{minHeight:'40vh'}}>
                <div className="column parent-width mb-s position-relative flex-1 " ref={this.gridContainer}>
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_COMPONENT_FORMULA}
                        displayTableName={" "}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.grid.gridData}
                        filter={this.grid.gridActions.filters}
                        currentPage={this.grid.gridActions.currentPage}
                        totalPageCount={this.grid.gridActions.totalPageCount}
                        addButtonConfig={[
                            
                        ]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {

                        }}
                        onSelection={(selection) => {
                        }}
                        isActionEnabled={true}

                        allowBulkOperation={false}
                        onCancelContext={() => {
                        }}
                        contextMenu={false}
                        onRowClick={(data) => {
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                        }}
                        isMenuVisible={false}
                        gridWidth={this.state.gridWidth}
                    />
                    {this.grid.gridData.rowData?.length <26 && this.getAddRowButton()}
                    {this.grid.gridData.rowData?.length != 0 &&<>
                        
                        {this.formulaField()}
                    </>}
                </div>
            </div>
            </>
        )
    }
    render() {
        return(
            <>
                {this.getGrid()}
                
            </>
        )
    }
}